import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap sm:flex-nowrap items-end gap-4" }
const _hoisted_2 = { class: "grow" }
const _hoisted_3 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_4 = { class: "mt-2 text-gray-600" }
const _hoisted_5 = { class: "grow md:grow-0 flex-shrink-0" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockHeader',
  props: {
  heading: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _renderSlot(_ctx.$slots, "heading", {}, () => [
          _createTextVNode(_toDisplayString(__props.heading), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_4, [
        _renderSlot(_ctx.$slots, "description", {}, () => [
          _createTextVNode(_toDisplayString(__props.description), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})